import { COLORS } from "./colors";
export var TEXT_COLOR_MAPPING = {
    "primary-dark-high": { color: COLORS.BLACK },
    "primary-dark-medium_high": { color: COLORS.P_MED_HIGH_EMPHASIS },
    "primary-dark-medium": { color: COLORS.P_MED_EMPHASIS },
    "primary-dark-medium_low": { color: COLORS.P_MED_LOW_EMPHASIS },
    "primary-dark-disabled": { color: COLORS.P_DISABLED },
    "primary-light-high": { color: COLORS.S_HIGH_EMPHASIS },
    "primary-light-medium": { color: COLORS.S_MED_EMPHASIS },
    "primary-light-disabled": { color: COLORS.S_DISABLED },
    "onsurface-dark-high": { color: COLORS.S_HIGH_EMPHASIS },
    "onsurface-dark-medium": { color: COLORS.S_MED_EMPHASIS },
    "onsurface-dark-disabled": { color: COLORS.S_DISABLED },
    "onsurface-light-high": { color: COLORS.BLACK },
    "onsurface-light-medium": { color: COLORS.P_MED_EMPHASIS },
    "onsurface-light-disabled": { color: COLORS.P_DISABLED },
    "primary-say-high": { color: COLORS.SAY_COBALT },
    "primary-say-medium": { color: COLORS.SHADED_COBALT },
    "primary-say-medium_low": { color: COLORS.PERIWINKLE },
    "primary-say-disabled": { color: COLORS.SAY_DISABLED },
    "error-dark-high": { color: COLORS.ERROR_DARK },
    "error-light-high": { color: COLORS.ERROR_LIGHT },
};
